import React from 'react';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import CustomButton from '../../../../components/buttons/CustomButton';

/**
 * Botão "PDF" das ações de um card de módulo, ligado a um `useReportExport`
 * (`report.start` gera, `report.exporting` trava o botão enquanto gera).
 */
const ModulePdfButton = ({ report }) => (
  <CustomButton
    variant="outlined"
    style="secondary"
    label={report.exporting ? 'Gerando...' : 'PDF'}
    icon={<PictureAsPdfOutlinedIcon />}
    enabled={!report.exporting}
    onClick={report.start}
  />
);

export default ModulePdfButton;
